import { css } from 'lit-element';
export default css([""]);
